import { render } from "./IncomeSummaryByProgram.vue?vue&type=template&id=48ae142e&scoped=true"
import script from "./IncomeSummaryByProgram.vue?vue&type=script&lang=js"
export * from "./IncomeSummaryByProgram.vue?vue&type=script&lang=js"

import "./IncomeSummaryByProgram.vue?vue&type=style&index=0&id=48ae142e&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ae142e"]])

export default __exports__